<template>
  <div class="game_request_form_container b-radius-12">
    <div class="d-flex-column gap-0">
      <h1 class="f-w-600 font-family-1 t-white title-h1">
        {{ $t("stay_tuned") }}!
      </h1>
      <p class="t-light regular-l font-family-2 text-center">
        {{ $t("stay_tuned_message") }}
      </p>
    </div>

    <form
      class="d-flex-row height-max-content form_container md-row-to-col"
      style="max-width: 500px"
      @submit.prevent="handleSubmit"
    >
      <input
        class="form_input font-family-2 t-white"
        type="email"
        v-model="email"
        :placeholder="$t('forms.wise_email')"
        :disabled="isLoading"
      />
      <button
        class="font-family-1 t-dark filled primary subscribe_btn medium-m"
      >
        {{ $t("membership.subscribe") }}
      </button>
    </form>
  </div>
</template>

<script setup>
const email = ref("");
const { locale } = useI18n();
const { setSnack } = useGenericStore();
const isLoading = ref(false);
const props = defineProps({
  game_id: {
    default: "",
  },
});
const handleSubmit = async () => {
  try {
    isLoading.value = true;
    const response = await useApiPost("/api/create-game-request", {
      method: "POST",
      body: {
        locale: locale.value,
        user_email: email.value,
        game_id: props.game_id,
        is_mmo_game: false,
      },
    });
    isLoading.value = false;
    console.log(response?.data);
    // console.log(response);
    if (response?.data) {
      setSnack({
        title: response?.data.message_title,
        description: response?.data.message,
        timeout: 5000,
        showProgress: true,
        type: response?.data?.message_status?.toLowerCase(),
        position: "top-right",
        isOpen: true,
      });
    }
  } catch (error) {
    isLoading.value = false;

    console.log(error);
  }
};
</script>
<style lang="scss">
.game_request_form_container {
  width: 100%;
  min-height: 450px;
  max-width: 1200px;
  // background-color: red;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-direction: column;
  padding: 8px 16px;
  position: relative;
  background-color: var(--bg-main);
  & > * {
    z-index: 1;
  }
  p {
    max-width: 400px;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 12px;
    height: 100%;
    width: 100%;
    z-index: 0;
    background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.4),
        rgba(0, 0, 0, 0.8)
      ),
      url(/images/games/gta-6-boost/gta-6-banner.webp);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    opacity: 0.8;
  }
  .form_container {
    border: 1px solid var(--stroke-dark);
    border-radius: 6px;
    min-height: 48px;
    background-color: var(--bg-light);
    &.error {
      border: 1px solid var(--danger);
    }
  }

  .form_input {
    width: 100%;
    outline: none;
    border: none;
    padding: 4px 16px;
    min-height: 48px;

    background-color: transparent;
  }
  .subscribe_btn {
    min-height: 48px;
    border-radius: 0 6px 6px 18px;
    padding: 8px;
    border: none !important;
    min-width: 20%;
  }
  @media screen and (max-width: 768px) {
    .subscribe_btn {
      width: 100%;
      border-radius: 0 0 6px 6px;
    }
  }
}
</style>
